"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedOption = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _utils = require("../../utils");
var _LoadingOption = require("./LoadingOption");
const VirtualizedOption = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    data,
    index,
    style
  } = _ref;
  const {
    getItemProps,
    getRenderedOption,
    highlightedIndex,
    options,
    getOptionKey,
    isOptionSelected,
    metadata
  } = data;
  const isLastRow = index === options.length;
  if (isLastRow) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: style
    }, /*#__PURE__*/_react.default.createElement(_LoadingOption.LoadingOption, null));
  }
  const option = options[index];
  const key = getOptionKey(option);
  return getRenderedOption(option, index, highlightedIndex, getItemProps({
    item: option,
    index,
    style: {
      ...style,
      width: "calc(100% - 16px)"
    },
    onClick: _utils.stopPropagationHandler,
    key
  }), isOptionSelected, metadata);
}, _reactWindow.areEqual);
exports.VirtualizedOption = VirtualizedOption;
VirtualizedOption.displayName = "VirtualizedOption";
//# sourceMappingURL=VirtualizedOption.js.map